import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import { __awaiter } from "tslib";
import cx from 'classnames';
import React, { useState, useRef, useLayoutEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { ShouldRender } from '../../utils/should-render';
import { useDeferredVisible } from '../../utils/use-deferred-visible';
import Mask from '../mask';
import Space from '../space';
import Image from '../image';
import { DialogActionButton } from './dialog-action-button';
var classPrefix = 'nib-dialog';
/** 动画入场持续时长（单位：毫秒） */

var ENTER_TIMEOUT = 300;
/** 动画离场持续时长（单位：毫秒） */

var EXIT_TIMEOUT = 100;
var defaultProps = {
  visible: false,
  actions: [],
  closeOnAction: false,
  closeOnMaskClick: false,
  destroyOnClose: false,
  forceRender: false,
  getContainer: function getContainer() {
    return document.body;
  },
  disableBodyScroll: true
};
export var Dialog = function Dialog(p) {
  var _cx;

  var props = mergeProps(defaultProps, p);
  var actions = props.actions;

  var _useState = useState(props.visible),
      active = _useState[0],
      setActive = _useState[1];

  var deferredVisible = useDeferredVisible(props.visible && active);
  useLayoutEffect(function () {
    if (props.visible) {
      setActive(true);
    }
  }, [props.visible]);

  var afterClose = function afterClose() {
    var _a;

    setActive(false);
    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
  };

  var ref = useRef(null);
  useLockScroll(ref, props.disableBodyScroll && active);
  var node = withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    style: {
      'display': active ? undefined : 'none',
      // @ts-ignore
      '--enter-timeout': ENTER_TIMEOUT + "ms",
      '--exit-timeout': EXIT_TIMEOUT + "ms"
    }
  }, /*#__PURE__*/React.createElement(Mask, {
    visible: deferredVisible,
    onMaskClick: props.closeOnMaskClick ? props.onClose : undefined,
    afterShow: props.afterMaskShow,
    destroyOnClose: props.destroyOnClose,
    disableBodyScroll: false,
    className: props.maskClassName,
    style: props.maskStyle
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: ref,
    in: deferredVisible,
    timeout: {
      enter: ENTER_TIMEOUT,
      exit: EXIT_TIMEOUT
    },
    classNames: classPrefix + "-main",
    onEntered: props.afterShow,
    onExited: afterClose,
    unmountOnExit: props.destroyOnClose
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(classPrefix + "-main", props.mainClassName),
    style: props.mainStyle
  }, props.image && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-image-container"
  }, /*#__PURE__*/React.createElement(Image, {
    src: props.image,
    fit: "cover",
    alt: "image"
  })), /*#__PURE__*/React.createElement(Space, {
    className: classPrefix + "-body",
    direction: "vertical",
    block: true
  }, Boolean(props.title) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-title"
  }, props.title), Boolean(props.content) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-content"
  }, props.content)), actions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-footer", (_cx = {}, _cx[classPrefix + "-footer-vertical"] = actions.length >= 3, _cx))
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(DialogActionButton, {
      key: action.key,
      action: action,
      onAction: function onAction() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _a, _b, closeOnClick;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (props.visible) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  _context.next = 4;
                  return (_a = props.onAction) === null || _a === void 0 ? void 0 : _a.call(props, action, index);

                case 4:
                  closeOnClick = action.closeOnClick;

                  if (closeOnClick || closeOnClick !== false && props.closeOnAction) {
                    (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      }
    });
  }))))));
  return /*#__PURE__*/React.createElement(ShouldRender, {
    active: active,
    forceRender: props.forceRender,
    destroyOnClose: props.destroyOnClose
  }, renderToContainer(props.getContainer, node));
};